var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.665 2.66498H3.66498C2.00812 2.66498 0.664978 4.00812 0.664978 5.66498V15.665C0.664978 17.3218 2.00812 18.665 3.66498 18.665H13.665C15.3218 18.665 16.665 17.3218 16.665 15.665V5.66498C16.665 4.00812 15.3218 2.66498 13.665 2.66498Z",
    stroke: "#666666",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66498 0.664978V2.66498M11.665 0.664978V2.66498",
    stroke: "#666666",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66498 12.165C10.0457 12.165 11.165 11.0457 11.165 9.66498C11.165 8.28427 10.0457 7.16498 8.66498 7.16498C7.28427 7.16498 6.16498 8.28427 6.16498 9.66498C6.16498 11.0457 7.28427 12.165 8.66498 12.165Z",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66498 16.165C3.66498 14.165 5.66498 12.665 8.66498 12.665C11.665 12.665 13.665 14.165 13.665 16.165",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactOutlined);
export default __webpack_public_path__ + "static/media/contact_outlined.e83c943f74fb4e35301e14165a159517.svg";
export { ForwardRef as ReactComponent };